module.exports = __webpack_public_path__ + "img/tractor.dd26ece4.svg";